import { extend } from "@react-three/fiber";
import { Text } from "troika-three-text";

import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'

extend({ Text });


export default function ThreeTextPanel({position, rotation, cardState, text, cardColor}){
    
    const rotationFixed = rotation ? [...rotation] : [0,0,0]
    const positionFixed = position ? [...position] : [0,0,0]
    
    
    
    rotationFixed[0] -= Math.PI / 2
    positionFixed[1] += .012

    if(cardState.cardLogoUrl) positionFixed[2] = .2
    if(cardState.cardType.name ==="basic") positionFixed[2] = .25
    
    
    const textConfig = {
        fontSize: .07,
        maxWidth: 300,
        lineHeight: 1,
        letterSpacing: 0,
        textAlign: "center",
        text,
        color: cardColor.contrastHex,
        position:positionFixed,
        rotation:rotationFixed,
        anchorX:"center",
        anchorY:"middle"
    }
    
    
    return (
        <mesh>
            <text  {...textConfig}/>
            <meshBasicMaterial />
        </mesh>
    )
}

